'use client';

import { useEffect } from 'react';
import type { StepConfig } from '../types';

interface UseStepVisibilityProps {
  visibleSteps: StepConfig[];
  currentStepId: string;
  stepsById: Record<string, StepConfig>;
  setCurrentStepId: (stepId: string) => void;
}

/**
 * Hook to ensure current step is visible, resetting if needed
 */
export const useStepVisibility = ({
  visibleSteps,
  currentStepId,
  stepsById,
  setCurrentStepId,
}: UseStepVisibilityProps) => {
  useEffect(() => {
    if (visibleSteps.length === 0) return;
    const isCurrentVisible = visibleSteps.some((s) => s.id === currentStepId);
    // Only reset if step doesn't exist in allSteps at all (not just not visible)
    // This allows navigation to steps that might not be currently visible (e.g., via back button)
    if (!isCurrentVisible && !stepsById[currentStepId]) {
      setCurrentStepId(visibleSteps[0].id);
    }
  }, [visibleSteps, currentStepId, stepsById, setCurrentStepId]);
};
